import axios from "axios";

let cancelTokenSource = axios.CancelToken.source();
// https://api.tnhlog.vn/v1
const axiosInstance = axios.create({
    // @ts-ignore
    baseURL: import.meta.env.VITE_API_URL || 'https://api.tnhlog.vn/v1',
    timeout: 150000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

axiosInstance.interceptors.request.use(function (config) {
    const token = localStorage.getItem('access_token');
    const locale = localStorage.getItem('language');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (locale) {
        config.headers['Accept-Language'] = locale;
    }
    config.cancelToken = cancelTokenSource.token; //it will update cancelToken on every call
    
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axiosInstance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    if (axios.isCancel(error)) {
        console.log("user cancel the network request");
        return Promise.reject("User cancel the network request.");
    }

    if (error?.response?.status === 401) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error.response.data);
});

export const handleCancelRequest = () => {
    cancelTokenSource.cancel("Request was canceled");
};

export const handleRefreshCancelRequest = () => {
    cancelTokenSource = axios.CancelToken.source();
}

export default axiosInstance;